import { StyleEntry } from 'Shared/backend/styleUtils';


export function overlayStyles(sizes,text): {[name: string]: StyleEntry}
{
	return {
		'Background of foreground': {
			explanation: 'Darkens the background of foreground image of an overlay. [unused. delete.]',
			rules: [{
				location: () => ['**','overlay','* foreground'],
				padding: () => ({sides:'all',all:'2em'}),
				css: () => ({
					backgroundColor: 'rgba(0, 0, 0, 0.56)'
				})
			}]
		},
	};
}

